import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import Shop from "../../../models/shop.model";
import { ReceiptOrder } from "../../../models/receipt.model";
import { DialogPrintReceiptComponent } from "../../dialog-print-receipt/dialog-print-receipt.component";
import { ReceiptOrderService } from "../../../services/receipt-order.service";
import { Router } from "@angular/router";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { User } from "../../../@core/data/users";
import { DialogPrintReceiptOrderComponent } from "../dialog-print-receipt-order/dialog-print-receipt-order.component";

@Component({
  selector: "ngx-dialog-view-receipt-order",
  templateUrl: "dialog-view-receipt-order.component.html",
  styleUrls: ["dialog-view-receipt-order.component.scss"],
})
export class DialogViewReceiptOrderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() shop?: Shop = new Shop();
  @Input() user: User;

  @Input() receipt: ReceiptOrder;
  @Input() receiptId?: string;

  loading: boolean = false;
  submitted: boolean = false;

  constructor(
    protected ref: NbDialogRef<DialogViewReceiptOrderComponent>,
    private receiptService: ReceiptOrderService,
    private dialogService: NbDialogService,
    private router: Router,
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDelete(id) {
    console.log("DialogViewReceiptComponent/onDelete:", id);
    this.ref.close(id);
  }

  close() {
    this.ref.close();
  }

  delete() {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.receiptService
            .delete(this.shopId, this.receipt.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.ref.close(this.receipt);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit() {
    this.ref.close();
    this.router.navigateByUrl(`/order/${this.receipt.id}`);
  }

  messageErr = "";
  printReceipt() {
    this.dialogService
      .open(DialogPrintReceiptOrderComponent, {
        context: {
          shopId: this.shopId,
          uid: this.user.uid,
          user: this.user,
          receipt: this.receipt,
          shop: this.shop,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }
}
